<h2 mat-dialog-title>Contacts for <span class="entity-name">{{campusName}}</span></h2>

<mat-dialog-content style="height:84%">
    <div class="edit-form">
        <app-campus-contact-editor [campusContactEditor]="campusContact"
                                    (saveNewContact)="saveEdit($event)"
                                    (updateContact)="updateContact($event)"
                                    (cancelEvent)="cancelEdit()">
        </app-campus-contact-editor>        
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-raised-button mat-dialog-close color="primary">Close</button>
</mat-dialog-actions>
